import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Custom hook for admin dashboard navigation
 * Handles URL-based tab management and routing
 */
export const useAdminNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // URL-based tab management
  const getActiveTabFromUrl = () => {
    const path = location.pathname;
    if (path === '/admin/users') return 'users';
    if (path === '/admin/user-approvals') return 'user-approvals';
    if (path === '/admin/subscriptions') return 'subscription-management';
    if (path === '/admin/subscription-plans') return 'subscriptions';
    if (path === '/admin/order-management') return 'order-management';
    if (path === '/admin/settings') return 'settings';
    if (path === '/admin/scraper-settings') return 'scraper-settings';
    if (path === '/admin/reports') return 'reports';
    if (path === '/admin/partner-wallet') return 'partner-wallet-admin';
    if (path === '/admin/partner-wallet-ledger') return 'partner-wallet-ledger';
    return 'overview'; // default for /admin/dashboard
  };
  
  const [activeTab, setActiveTab] = useState(getActiveTabFromUrl());
  
  // URL synchronization effect
  useEffect(() => {
    const tabFromUrl = getActiveTabFromUrl();
    if (tabFromUrl !== activeTab) {
      setActiveTab(tabFromUrl);
    }
  }, [location.pathname, activeTab]);
  
  // Tab navigation function
  const handleTabChange = (tab) => {
    const routeMap = {
      'overview': '/admin/dashboard',
      'users': '/admin/users',
      'user-approvals': '/admin/user-approvals',
      'subscriptions': '/admin/subscription-plans',
      'subscription-management': '/admin/subscriptions',
      'order-management': '/admin/order-management',
      'settings': '/admin/settings',
      'scraper-settings': '/admin/scraper-settings',
      'reports': '/admin/reports',
      'partner-wallet-admin': '/admin/partner-wallet',
      'partner-wallet-ledger': '/admin/partner-wallet-ledger'
    };
    navigate(routeMap[tab] || '/admin/dashboard');
  };
  
  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };
  
  return {
    activeTab,
    handleTabChange,
    handleLogout
  };
};